import React from 'react';
import { Flex, WhiteSection } from './base/layout-components';
import Text from './base/Text';
import Icon from './base/Icon';

const NoDataWhiteSection = ({
  minHeight = '15rem',
  noDataConditionFc = () => false,
  text = 'No data was found, please try again later',
  svg = 'Warning',
  display = 'block',
  children
}) => {
  return (
    <WhiteSection
      l='1rem'
      r='1rem'
      t='1rem'
      b='1rem'
      display={display}
      minHeight={minHeight}
      width='100%'
    >
      {noDataConditionFc() ? (
        <Flex
          width='100%'
          height='100%'
          justify='center'
          items='center'
          direction='column'
          minHeight={minHeight}
        >
          <Text
            size='x-large'
            weight='600'
            color='gray'
            pb='medium'
            align='center '
          >
            {text}
          </Text>
          {React.isValidElement(svg) ? (
            svg
          ) : (
            <Icon name={svg} size='xx-large' color='gray' />
          )}
        </Flex>
      ) : (
        <>{children}</>
      )}
    </WhiteSection>
  );
};

export default NoDataWhiteSection;
